
import Typography from '@/ui-kit/components/typography';
import Gutter from '@/ui-kit/components/gutter';
import { TypographyType, TypographyProperty } from '@/ui-kit/components/typography/enums';
import { ButtonProperty, ButtonPropsEventType } from '@/ui-kit/components/button/enums';
import { GutterProperty } from '@/ui-kit/components/gutter/enums';
import Button from '@/ui-kit/components/button';
import Icon from '@/ui-kit/components/icon';
import {
  StyleColorSchemeType, StylePositionType, StyleSizeType,
} from '@/ui-kit/styles/enums';
import { IconType } from '@/ui-kit/components/icon/enums';

export default {
  name: 'SoldPropertyActions',
  components: {
    Gutter,
    Typography,
    Button,
    Icon,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    listing: {
      type: Object,
      required: true,
    },
    isOwnershipClaiming: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      TypographyType,
      TypographyProperty,
      GutterProperty,
      StyleSizeType,
      StylePositionType,
      StyleColorSchemeType,
      IconType,
      ButtonProperty,
      ButtonPropsEventType,
    };
  },
  computed: {
    isCreateDashboardButtonDisplayed() {
      // NOTE: For MVP of the Homeowner Dashboard we assume that a user can only own a single property.
      return !!this.user.isAuthenticated && !this.user.propertyOwnerships?.length && !this.ownership;
    },
    isYourPropertyChipDisplayed() {
      return !!this.user.propertyOwnerships?.find((ownership) => ownership.propertyId === this.propertyId);
    },
    ownership() {
      return this.listing.ownership;
    },
    propertyId() {
      return this.listing.propertyId;
    },
    isAdmin() {
      return this.user?.roles.admin;
    },
  },
  methods: {
    handleCreateDashboardClick() {
      this.$emit('createDashboardClick');
    },
  },
};
